import React from 'react';
import { bool, shape, string } from 'prop-types';

const XlsxFileColor = ({
  className = 'icon',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M10.5 1.5H4.5C3.675 1.5 3.0075 2.175 3.0075 3L3 15C3 15.825 3.6675 16.5 4.4925 16.5H13.5C14.325 16.5 15 15.825 15 15V6L10.5 1.5ZM4.5 15V3H9.75V6.75H13.5V15H4.5ZM6.75 9L6.375 9.9375L6 9H5.25L6 10.875L5.25 12.75H6L6.375 11.8125L6.75 12.75H7.5L6.75 10.875L7.5 9H6.75ZM11.25 9C10.8358 9 10.5 9.33579 10.5 9.75V11.25H12V12H10.5V12.75H12C12.4142 12.75 12.75 12.4142 12.75 12V10.5H11.25V9.75H12.75V9H11.25ZM8.25 12V9H9V12H9.75V12.75H9C8.58579 12.75 8.25 12.4142 8.25 12Z" fill="currentColor" />
  </svg>
);

XlsxFileColor.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default XlsxFileColor;
